import { gql } from "@apollo/client";

import {
  PRINT_USER_PROFILE_FIELDS,
  USER_REPORT_PRINT_EXTENSION_FIELDS,
  USER_RESULT_PRINT_CORE_FIELDS
} from "@/components/reports/print/fragments";

import { REPORT_FIELDS } from "./queries";

const USER_REPORT_FIELDS = gql`
  fragment UserReportFields on UserReportType {
    id
    name
    slug
    publicationStatus
    publishedViews
  }
`;

export const WARD_USER_REPORT_PRINT_QUERY = gql`
  query WardUserReportPrintQuery($subsectorSlug: String!, $userId: ID!) {
    report(slug: $subsectorSlug, userId: $userId) {
      ...ReportFields
    }
    userReport(subsectorSlug: $subsectorSlug, userId: $userId) {
      ...UserReportFields
      ...UserReportPrintExtensionFields
    }
    user(userId: $userId) {
      ...PrintUserProfileFields
    }
  }
  ${REPORT_FIELDS}
  ${USER_REPORT_FIELDS}
  ${USER_REPORT_PRINT_EXTENSION_FIELDS}
  ${PRINT_USER_PROFILE_FIELDS}
`;

export const WARD_USER_RESULT_PRINT_DETAILS_QUERY = gql`
  query WardUserResultPrintDetailsQuery($userResultId: ID!, $userId: ID!) {
    userResult(userResultId: $userResultId, userId: $userId) {
      ...UserResultPrintCoreFields
      untestedDnaDatapoints {
        id
        name
      }
      untestedDatapoints {
        id
        name
        description
        function
        reason
        advertisedTestProductName
      }
    }
  }
  ${USER_RESULT_PRINT_CORE_FIELDS}
`;
